import { Domain } from '../types';

export const getDomainNames = (schemas: string[], domains?: Domain[]) =>
  schemas.map((schema) => domains?.find((domain) => domain.domain === schema)?.name || schema);
